import { api } from './client';

export interface IrnResult {
  irn: string;
  ackNo: string;
  ackDate: string;
  irnStatus: string;
  note?: string;
}

export interface EwbResult {
  ewbNo: string;
  ewbDate: string;
  ewbValidUpto: string;
  ewbStatus: string;
  note?: string;
}

export const eInvoicingApi = {
  generateIrn: (invoiceId: string) => api.post<IrnResult>(`/e-invoicing/${invoiceId}/generate`, {}),
  cancelIrn: (invoiceId: string, reason: string) => api.post<{ irnStatus: string }>(`/e-invoicing/${invoiceId}/cancel`, { reason }),
};

export const ewayBillApi = {
  generateEwb: (invoiceId: string) => api.post<EwbResult>(`/eway-bill/${invoiceId}/generate`, {}),
  cancelEwb: (invoiceId: string, reason: string) => api.post<{ ewbStatus: string }>(`/eway-bill/${invoiceId}/cancel`, { reason }),
  extendEwb: (invoiceId: string, additionalDays: number) => api.post<{ ewbValidUpto: string }>(`/eway-bill/${invoiceId}/extend`, { additionalDays }),
};
